import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './features/auth/AuthProvider';
import { ToastProvider } from './components/ui/ToastProvider';

// Design tokens first, then the reset and the component layers.
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/forms.css';
import './styles/layout.css';
import './styles/table.css';
import './styles/overlays.css';
import './styles/wizard.css';
import './styles/pages.css';
import './styles/auth.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
